module.exports = __webpack_public_path__ + "img/Intro-AddMenu.6aa42280.png";